/**
 * CLICKAR.BIZ INTERNATIONAL REST API
 * Some custom description of API.
 *
 * OpenAPI spec version: API V1
 * Contact: blu@reply.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable, Optional } from "@angular/core";
import { environment } from "@app/../environments/environment";
import { CodeTable, CTGroupDTO } from "@shared/services/code-table/code-table.model";
import { Configuration } from "@shared/services/utils/configuration";
import { CustomHttpUrlEncodingCodec } from "@shared/services/utils/encoder";
import { Observable } from "rxjs";

@Injectable()
export class CodeTableService {
	private basePath = environment.baseApiUrl;
	defaultHeaders = new HttpHeaders();
	configuration = new Configuration();
	readonly encoderParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

	constructor(
		protected httpClient: HttpClient,
		@Optional() configuration: Configuration
	) {
		if (configuration) {
			this.configuration = configuration;
			this.basePath ??= configuration.basePath;
		}
	}

	/**
	 * @param consumes string[] mime-types
	 * @return true: consumes contains "multipart/form-data", false: otherwise
	 */
	/* 	private canConsumeForm(consumes: string[]): boolean {
			const form = "multipart/form-data";
			for (const consume of consumes) {
				if (form === consume) {
					return true;
				}
			}
			return false;
		}
	 */

	/**
	 * getCTElementsMap
	 *
	 * @param groupCodes groupCodes
	 * @param idMarkets idMarkets
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getCTElementsMapUsingGET(groupCodes: string[], idMarkets: string[], observe?: "body", reportProgress?: boolean): Observable<{ [key: string]: CodeTable[]; }>;
	getCTElementsMapUsingGET(groupCodes: string[], idMarkets: string[], observe?: "response", reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: CodeTable[]; }>>;
	getCTElementsMapUsingGET(groupCodes: string[], idMarkets: string[], observe?: "events", reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: CodeTable[]; }>>;
	getCTElementsMapUsingGET(groupCodes: string[], idMarkets: string[], observe: any = "body", reportProgress = false): Observable<any> {
		if (groupCodes === null || groupCodes === undefined) {
			throw new Error("Required parameter groupCodes was null or undefined when calling getCTElementsMapUsingGET.");
		}

		if (idMarkets === null || idMarkets === undefined) {
			throw new Error("Required parameter idMarkets was null or undefined when calling getCTElementsMapUsingGET.");
		}

		let queryParameters = this.encoderParameters;
		if (groupCodes) {
			for (const element of groupCodes) {
				queryParameters = queryParameters.append("groupCodes", <any>element);
			}
		}
		if (idMarkets) {
			for (const element of idMarkets) {
				queryParameters = queryParameters.append("idMarkets", <any>element);
			}
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<{ [key: string]: CodeTable[]; }>(`${this.basePath}/api/v1/open/ct-elements-map`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getCTElements
	 *
	 * @param groupCode groupCode
	 * @param elementCode elementCode
	 * @param idMarket idMarket
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getCTElementsUsingGET(groupCode: string, idMarket: string, elementCode?: string, observe?: "body", reportProgress?: boolean): Observable<CodeTable[]>;
	getCTElementsUsingGET(groupCode: string, idMarket: string, elementCode?: string, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<CodeTable[]>>;
	getCTElementsUsingGET(groupCode: string, idMarket: string, elementCode?: string, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<CodeTable[]>>;
	getCTElementsUsingGET(groupCode: string, idMarket: string, elementCode?: string, observe: any = "body", reportProgress = false): Observable<any> {
		if (groupCode === null || groupCode === undefined) {
			throw new Error("Required parameter groupCode was null or undefined when calling getCTElementsUsingGET.");
		}

		let queryParameters = this.encoderParameters;
		if (elementCode !== undefined && elementCode !== null) {
			queryParameters = queryParameters.set("elementCode", <any>elementCode);
		}
		if (groupCode !== undefined && groupCode !== null) {
			queryParameters = queryParameters.set("groupCode", <any>groupCode);
		}
		if (idMarket) {
			queryParameters = queryParameters.append("idMarket", <any>idMarket);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<CodeTable[]>(`${this.basePath}/api/v1/open/ct-elements`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getCTGroup
	 *
	 * @param groupCode groupCode
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getCTGroupUsingGET(groupCode?: string[], observe?: "body", reportProgress?: boolean): Observable<CTGroupDTO[]>;
	getCTGroupUsingGET(groupCode?: string[], observe?: "response", reportProgress?: boolean): Observable<HttpResponse<CTGroupDTO[]>>;
	getCTGroupUsingGET(groupCode?: string[], observe?: "events", reportProgress?: boolean): Observable<HttpEvent<CTGroupDTO[]>>;
	getCTGroupUsingGET(groupCode?: string[], observe: any = "body", reportProgress = false): Observable<any> {
		let queryParameters = this.encoderParameters;
		if (groupCode) {
			for (const element of groupCode) {
				queryParameters = queryParameters.append("groupCode", <any>element);
			}
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<CTGroupDTO[]>(`${this.basePath}/api/v1/open/ct-group`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}
}